import PropTypes from "prop-types";
import { createContext, useState } from "react";
import { toast } from "../../../core/helpers/message-helper";
import { obtenerPersonaHasSubAreas } from "../../../core/services/areas-service";

const SubAreasContext = createContext({});

export function SubAreasPersonaProvider({ children }) {
    const [personaHasSubAreas, setPersonaHasSubAreas] = useState(
        new Map([
            ["nuevas", new Map()],
            ["actuales", new Map()],
            ["aEliminar", new Map()],
        ])
    );

    const agregarSubArea = (subArea) => {
        setPersonaHasSubAreas((prev) => {
            const subAreas = new Map(prev.entries());
            const key = `${subArea.sub_area_id}-${subArea.area_id}-${subArea.sede_id}`;

            if (
                subAreas.get("actuales").get(key) == null &&
                subAreas.get("aEliminar").get(key) == null
            ) {
                subAreas.get("nuevas").set(key, subArea);
            } else if (subAreas.get("aEliminar").get(key) != null) {
                const subArea = subAreas.get("aEliminar").get(key);
                subAreas.get("aEliminar").delete(key);
                subAreas.get("actuales").set(key, subArea);
            }

            return subAreas;
        });
    };

    const eliminarSubArea = (key) => {
        setPersonaHasSubAreas((prev) => {
            const subAreas = new Map(prev.entries());

            if (subAreas.get("nuevas").get(key) != null) {
                subAreas.get("nuevas").delete(key);
            } else if (subAreas.get("actuales").get(key) != null) {
                const subArea = subAreas.get("actuales").get(key);
                subAreas.get("aEliminar").set(key, subArea);
                subAreas.get("actuales").delete(key);
            }

            return subAreas;
        });
    };

    const consultarPersonaHasSubArear = async (idPersona) => {
        const resp = await obtenerPersonaHasSubAreas(idPersona);
        if (!resp.status) return toast.error(resp.message);

        setPersonaHasSubAreas((prev) => {
            const subAreas = new Map(prev.entries());

            resp.data.forEach((personaHSA) => {
                const key = `${personaHSA.sub_area_id}-${personaHSA.area_id}-${personaHSA.sede_id}`;
                subAreas.get("actuales").set(key, personaHSA);
            });

            return subAreas;
        });
    };

    const limpiarSubAreas = () => {
        setPersonaHasSubAreas((prev) => {
            const subAreas = new Map(prev.entries());
            subAreas.get("actuales").clear();
            subAreas.get("aEliminar").clear();
            subAreas.get("nuevas").clear();
            return subAreas;
        });
    };

    return (
        <SubAreasContext.Provider
            value={{
                personaHasSubAreas,
                agregarSubArea,
                eliminarSubArea,
                limpiarSubAreas,
                consultarPersonaHasSubArear,
            }}
        >
            {children}
        </SubAreasContext.Provider>
    );
}

SubAreasPersonaProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};

export default SubAreasContext;
